// -----------------------------------------------------------------------------
// PLUGINS/ELEMS
// -----------------------------------------------------------------------------
import { setBlockType, toggleMark, wrapIn, lift } from "prosemirror-commands";
import { wrapInList, liftListItem } from "prosemirror-schema-list";
// -----------------------------------------------------------------------------
import icons from "../util/icons";
import { Link } from "./link";
import { Liftable } from "./liftable";
import { MenuStandardItem } from "./standard";
import { Media } from "./media";
import { innerBlockActive, outerBlockActive, markActive, leafActive } from "../util/selection";
// -----------------------------------------------------------------------------
export default {
    rule(editor) {
        return new MenuStandardItem(editor, {
            command(state, dispatch) {
                if (dispatch) {
                    dispatch(state.tr
                        .replaceSelectionWith(editor.state.schema.nodes.rule.create())
                        .scrollIntoView());
                }
                return true;
            },
            dom: icons.rule("df-ed-mu__icon"),
            active: leafActive(editor.state.schema.nodes.rule)
        });
    },
    link(editor, key, _id, _app, container) {
        return new Link(editor, container, editor.state.schema.marks.link, key);
    },
    media(editor, key, id, app, container) {
        return new Media(editor, container, editor.state.schema.nodes.image, key, id, app);
    },
    em(editor) {
        return new MenuStandardItem(editor, {
            command: toggleMark(editor.state.schema.marks.em),
            dom: icons.italic("df-ed-mu__icon"),
            active: markActive(editor.state.schema.marks.em)
        });
    },
    strong(editor) {
        return new MenuStandardItem(editor, {
            command: toggleMark(editor.state.schema.marks.strong),
            dom: icons.bold("df-ed-mu__icon"),
            active: markActive(editor.state.schema.marks.strong)
        });
    },
    h1(editor) {
        return new MenuStandardItem(editor, {
            command: setBlockType(editor.state.schema.nodes.h1),
            dom: icons.h1("df-ed-mu__icon"),
            active: innerBlockActive(editor.state.schema.nodes.h1, {})
        });
    },
    h2(editor) {
        return new MenuStandardItem(editor, {
            command: setBlockType(editor.state.schema.nodes.h2),
            dom: icons.h2("df-ed-mu__icon"),
            active: innerBlockActive(editor.state.schema.nodes.h2, {})
        });
    },
    h3(editor) {
        return new MenuStandardItem(editor, {
            command: setBlockType(editor.state.schema.nodes.h3),
            dom: icons.h3("df-ed-mu__icon"),
            active: innerBlockActive(editor.state.schema.nodes.h3, {})
        });
    },
    paragraph(editor) {
        return new MenuStandardItem(editor, {
            command: setBlockType(editor.state.schema.nodes.paragraph),
            dom: icons.paragraph("df-ed-mu__icon"),
            active: innerBlockActive(editor.state.schema.nodes.paragraph, {})
        });
    },
    blockquote(editor) {
        return new Liftable(editor, {
            lift: lift,
            sink: wrapIn(editor.state.schema.nodes.blockquote),
            icon: icons.blockquote("df-ed-mu__icon"),
            active: outerBlockActive(editor.state.schema.nodes.blockquote, {})
        });
    },
    orderedList(editor) {
        return new Liftable(editor, {
            lift: liftListItem(editor.state.schema.nodes.list_item),
            sink: wrapInList(editor.state.schema.nodes.ordered_list),
            icon: icons.orderedlist("df-ed-mu__icon"),
            active: outerBlockActive(editor.state.schema.nodes.ordered_list, {})
        });
    },
    bulletList(editor) {
        return new Liftable(editor, {
            lift: liftListItem(editor.state.schema.nodes.list_item),
            sink: wrapInList(editor.state.schema.nodes.bullet_list),
            icon: icons.bulletlist("df-ed-mu__icon"),
            active: outerBlockActive(editor.state.schema.nodes.bullet_list, {})
        });
    }
};
